export default __webpack_public_path__ + "static/media/asset.4da953f4.png";